<template>
  <!-- prettier-ignore -->
  <div class="row-wrapper">
    <div :class="classes">
      <div class="row-title row-cell">
        <ovp-icon
          v-if="icon"
          art="light"
          class="row-title-icon"
          :name="icon"
        />
        <span
          class="row-title-text"
          :class="{'row-title-text--bold' : isMainType}"
          v-html="title"
        />
      </div>

      <template v-if="showContent">
        <div
          v-for="(item, index) in contentArray"
          :key="index"
          class="content row-cell"
          :class="{'content--selected': index === selectedContentColumn}"
          v-html="item" />
      </template>

    </div>
  </div>
</template>
<script>
export default {
  name: 'TableRow',
  props: {
    icon: {
      type: String,
      default: '',
    },
    isMainType: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },

    selectedContentColumn: {
      type: Number,
      required: true,
    },
    contentArray: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showContent() {
      // always displayed in desktop mode for highlighting of selected column
      return (
        this.contentArray.some(content => !!content) || this.$browser.isDesktop
      )
    },

    classes() {
      return {
        row: true,
        'row-has-two-columns': this.contentArray.length === 2,
        'row-has-three-columns': this.contentArray.length === 3,
        'row-has-four-columns': this.contentArray.length === 4,
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.row {
  display: grid;
  min-width: 100%;
  background-color: var(--c-white);

  &-wrapper {
    display: inline-block;
    vertical-align: top;
    min-width: 100%;
    border-top: 1px solid var(--c-dark-gray);

    &:first-of-type {
      border-top: none;
    }
    &:last-of-type {
      border-bottom: 1px solid var(--c-dark-gray);
    }
  }

  grid-template-columns: minmax(220px, 1fr);

  &-has-two-columns {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  &-has-three-columns {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
  }

  &-cell {
    padding: 8px 16px;
  }

  &-title {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    grid-column: 1/-1;
    font-size: 14px;
    line-height: 20px;
    background-color: var(--c-warm-gray);
    color: var(--c-black);
    min-height: 36px;

    &-icon {
      font-size: 20px;
      width: 20px;
      color: var(--c-black);
    }
    &-text {
      display: inline-block;
      margin-left: 8px;

      &--bold {
        font-weight: bold;
        >>> p {
          font-weight: normal;
        }
      }
    }
  }

  .content {
    word-break: break-word;

    >>> em {
      color: var(--c-black);
    }

    &--selected {
      background-color: #e0efeb;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .row {
    grid-template-columns: 220px minmax(220px, 1fr);
    &-has-two-columns {
      grid-template-columns: 220px repeat(2, minmax(220px, 1fr));
    }

    &-has-three-columns {
      grid-template-columns: 220px repeat(3, minmax(220px, 1fr));
    }

    &-title {
      grid-column: unset;
      background-color: var(--c-white);
      position: unset;
      left: unset;

      &-text {
        margin-left: 16px;
      }
    }

    .content {
    }
  }
}
</style>
